(() => {
  function initialize(root) {
    root.querySelectorAll('[data-kolo-collections]').forEach(section => {
      if (section.dataset.koloReady) return;
      section.dataset.koloReady = 'true';
      section.querySelectorAll('[data-kolo-filter]').forEach(button => {
        button.addEventListener('click', () => {
          section.querySelectorAll('[data-kolo-filter]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
          section.querySelectorAll('[data-kolo-category]').forEach(card => { card.hidden = button.dataset.koloFilter !== 'all' && card.dataset.koloCategory !== button.dataset.koloFilter; });
        });
      });
    });
  }
  initialize(document);
  if (!window.koloEditorListener) {
    document.addEventListener('shopify:section:load', event => initialize(event.target));
    window.koloEditorListener = true;
  }
})();
